// キー操作でスピードを出せるようにする（2026-09-29 ユーザー指示「タブで次へ・Enter で検索・確認モーダルは Enter で確定」）。
// 呼び出し元（約200のモーダル）は触らず、document の keydown と BootstrapVue のモーダル表示イベントで一括で効かせる。
//   - Ctrl(⌘)+Enter でモーダル・設定保存バーの主ボタン、Enter / Ctrl(⌘)+Enter で詳細フィルタの「適用」を押す
//     （フォームは Enter 単体では確定しない。判定は utils/keyboardOperation.js）
//   - モーダルを開いたら最初の入力欄にフォーカス（タッチ端末はキーボードが出るのでしない）
// 確認ダイアログ（msgBoxConfirm / $confirm）は「OK / はい」にフォーカスを置くので Enter で確定する
// （plugins/confirmDialogStyle.js の autoFocusButton・components/util/ConfirmDialog.vue）。
import { resolveEnterButton, findInitialField } from '~/utils/keyboardOperation'

export function onDocumentKeydown(event) {
  const button = resolveEnterButton(event)
  if (!button) return
  event.preventDefault()
  button.click()
}

function isTouchDevice(win) {
  return !!(
    win.matchMedia &&
    win.matchMedia('(hover: none) and (pointer: coarse)').matches
  )
}

// modalId: bv::modal::shown の第2引数（.modal の id）。無ければフォーカス中の要素からモーダルを探す
export function focusInitialField(doc, win, modalId) {
  if (isTouchDevice(win)) return false
  const active = doc.activeElement
  const modal = modalId ? doc.getElementById(modalId) : null
  const content =
    (modal && modal.querySelector('.modal-content')) ||
    (active && active.closest && active.closest('.modal-content')) ||
    (active && active.querySelector && active.querySelector('.modal-content'))
  const field = findInitialField(content, active)
  if (!field) return false
  field.focus()
  return true
}

export function installKeyboardOperation({
  app,
  doc = document,
  win = window
} = {}) {
  if (doc.__gymsKeyboardOperation) return false
  Object.defineProperty(doc, '__gymsKeyboardOperation', { value: true })
  // 各部品の Enter ハンドラ（候補選択など）が先に preventDefault できるよう、バブリングで最後に見る
  doc.addEventListener('keydown', onDocumentKeydown)
  if (app) {
    const mounted = app.mounted
    app.mounted = function () {
      if (mounted) mounted.call(this)
      // shown の直後に BootstrapVue がモーダル本体へフォーカスする（requestAnimationFrame）が、
      // フォーカスがすでにモーダル内にあれば動かさないので、ここで先に入力欄へ置く
      this.$on('bv::modal::shown', (_bvEvent, modalId) =>
        focusInitialField(doc, win, modalId)
      )
    }
  }
  return true
}

export default ({ app }) => {
  installKeyboardOperation({ app })
}
